import { setTranslations } from 'react-i18nify'
import en from './en'
import { t, Replacements } from 'react-i18nify'

export function initializeI18n(): void {
  setTranslations({
    en,
  })
}

export function buildTranslate(prefix: string): typeof t {
  return (key: string, replacements?: Replacements) =>
    t(`${prefix}.${key}`, replacements)
}
